import { H1 } from "components/shared/Heading";
import styled from "styled-components";

export const HeroTitle = styled(H1)`
    color: ${({ theme }) => theme.colors.tertiary[800]};
    background-color: white;
    padding: 8px 16px;
    text-transform: uppercase;
    width: fit-content;
`;
